import React, { useEffect, useState } from 'react';
import Styles from "./styles.module.scss";
import Button from "../../components/button";
import levelIcon from "../../assets/images/level_icon.svg";
import priceIcon from "../../assets/images/resources-price.svg";
import crownIcon from "../../assets/images/crown_icon.svg";
import Table from "../../components/selectTable";
import {
  GridPageChangeEvent,
  GridPagerSettings,
} from "@progress/kendo-react-grid";
import { Error } from "@progress/kendo-react-labels";
import SearchBar from '../../components/searchbar';

interface AppState {
  items: any;
  total: number;
  skip: number;
  pageSize: number;
  pageable: GridPagerSettings;
}




function ApplyResourceTable(props: any) {
  
  const [error, setError] = useState<string>()
  const [count, setCount] = useState<number>(0)
  const data: any = JSON.parse(localStorage.getItem("resourceApplyPositions") || "") || null
  const [selectedCandidates, setSelectedCandidates] = useState([])


  const createState = (skip: number, take: number, items: any) => {
    let pagerSettings: GridPagerSettings = {
      buttonCount: 20,
      info: true,
      type: "numeric",
      pageSizes: [25, 50, 100],
      previousNext: true,
    };
    return {
      items: items,
      total: props.total && props.total,
      skip: skip,
      pageSize: take,
      pageable: pagerSettings,
    };
  };

  const [state, setState] = useState<AppState>(createState(0, 25, props.data));

  useEffect(() => {

    setState(createState(state.skip, state.pageSize, props.data));
 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.total])
  


  const pageChange = (event: GridPageChangeEvent) => { 
    setState(createState(event.page.skip, event.page.take, props.data));
    
    props.pageSize(event.page.take, event.page.skip) 
  }
  
  const pageSize = (pageSize:any, pageNumber: number) => { 
    props.pageSize(pageSize, pageNumber)
  }
  

  const onSelection =  (data: any) => {
    setSelectedCandidates(data) 
    setCount(data.length)
    setError('')
    
  }

  const submitResource = () => {

    if (selectedCandidates && selectedCandidates.length > 0) {
      if (selectedCandidates && selectedCandidates.length > 1) {
        setError('Select only one position')
      } else {
      props.onSubmit(selectedCandidates)
      }
    } else {
      setError('Select atleast one position')
    }
  }

  const onRowClick = (data: any) => {
    setSelectedCandidates(data)
  }

    return (
      <>
        <div className="table-content-wrapper">
          <h3 className="headWithLabel">
            Resource Description<label className={''}>{'' }</label>
          </h3>
          <div className={Styles.jobStatusWrap}>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={crownIcon} />
              </figure>
              <figcaption>Job Role</figcaption>
              <h2>{data && data.jobRoles && data.jobRoles.toString()}</h2>
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={levelIcon} />{" "}
              </figure>
              <figcaption>Experience</figcaption>
          <h2>{data && data.experience} Years</h2>           
            </div>
            <div className={Styles.jobStatus}>
              <figure>
                <img alt='' src={priceIcon} />
              </figure>
              <figcaption>Resource Rate</figcaption>
              <h2>{data && data.currencyType === 'INR' ? '₹' :  '$'}{data && data.rates}</h2>
            </div>              
        </div>
        </div>
        <section className={Styles.dashboardWrapper}>
          <div className="table-content-wrapper">
          <div className={Styles.resourceHead}>
            <div className="tableHead">
                <div className="tableTitle">
                  <h2>Positions</h2>
                  <p>{`${count} positions selected`}</p>
                </div>
                <Button onClick={submitResource} variant="primary" size="small">
                Apply for this Position
              </Button>
            </div> 
            {/* <div className={Styles.resourceSearch}> */}
                {/* <SearchBar  searchChange={props.searchChange} filtervalues={props.filtervalues} onClick={() => setFilter((prev) => !prev)} tagClose={props.closeTag} /> */}
              <SearchBar searchChange={props.searchChange} filtervalues={props.filtervalues} tagClose={props.closeTag} />
                {/* <div className={Styles.resourceAdd}>
                  <button  className="link-btn">
                  <Icon icon="ic:round-plus" /> Add New Resource
                  </button>
                </div>
            </div> */}
          </div>
          <Error>{error}</Error>
           
            <Table type='resources' data={props.data} total={props.total} state={state} pageChange={pageChange} pageSize={pageSize} onSelection={onSelection} onRowClick={onRowClick}/>
          </div>
        </section>
        {/* {filter && <ResourceFilter onClose={() => setFilter(false)} defaultValues={props.filtervalues} allocatedTo={props.allocatedTo} ClickHandler={(data: any) => { props.applyFilter(data); setFilter(false)}} />} */}
      </>
    );
    }
    
    export default ApplyResourceTable
